
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destination/[state]",
      function () {
        return require("private-next-pages/destination/[state]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destination/[state]"])
      });
    }
  